module.exports = __webpack_public_path__ + "static/media/addProduct.3dff302b.png";